import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterTypes } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { FilterPredefinedDate } from 'app/components/filters/filters-panel/filter-types/filter-predefined-date/filter-predefined-date';

export const predefinedDateConfiguration = {
  [FilterTypes.PredefDate]: filterConfiguration(
    FilterPredefinedDate,
    undefined,
    [customFilterFieldPostfix.predefDate]
  )
};
